import { defineMessages } from 'react-intl';

export default defineMessages({
	brandingPreviewText: {
		defaultMessage: 'You are currently previewing your global branding changes',
		description: 'Global Branding Preview Banner Text',
		id: 'cv.branding.preview.banner.text.non-final',
	},
});
